export const usePauseQueries = (): boolean => false;
